import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '../../environments/environment';

export const customerFeatureGuard = () => {
  const router = inject(Router);

  if (environment.EnableCustomerPortal) {
    return true;
  }

  router.navigate(['/home']);
  return false;
};
